import { getContracts } from "./getContracts";
import { callMethod } from "./callMethod";
import { sendMethod } from "./sendMethod";
import { resetMethod } from "./resetMethod";

const exportVar = [getContracts, callMethod, sendMethod, resetMethod];
export default exportVar;
